import Repository from './Repository'

export default new Repository('notifications/summary')


// WEBPACK FOOTER //
// ./src/repositories/NotificationsSummaryRepository.js